import BaseService from './base.service';

export default class AdminService extends BaseService {
  async getAdministrators(criteria, workspaceId) {
    const queryItems = [`workspaceId=${workspaceId}`];

    Object.keys(criteria).forEach((key) => {
      if (criteria[key] || criteria[key] === 0) {
        queryItems.push(`${key}=${criteria[key]}`);
      }
    });

    const queryString = queryItems.length ? `?${queryItems.join('&')}` : '';
    return this.get(`/admins${queryString}`);
  }

  async getActiveAdminInWorkspace() {
    return this.get(`/admins/active`);
  }

  reInviteAdmin(name, phoneNumber, email, id, workspaceId) {
    const body = {
      email,
      name,
      phoneNumber,
      workspaceId,
    };
    return this.put(`/admins/resend-invitation/${id}`, body);
  }

  inviteAdmin(name, phoneNumber, email, workspaceId) {
    const body = {
      email,
      name,
      phoneNumber,
      workspaceId,
    };
    return this.post(`/admins`, body);
  }

  disableAdmin(adminId) {
    return this.put(`/admins/disable/${adminId}`);
  }

  enableAdmin(adminId) {
    return this.put(`/admins/enable/${adminId}`);
  }
}
